import React, { Component } from 'react';
import { connect } from 'react-redux';
import TravelSummaryBarComponent from './TravelSummaryBarComponent';
import { setTravelSummaryBarHeight } from 'state/refs/actions';
import { IN_PROGRESS as FETCHING_STATUS_IN_PROGRESS } from 'constants/status/fetchingStatus';

class TravelSummaryBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };

    this.handleOnClickOpenSummary = this.handleOnClickOpenSummary.bind(this);

    this.travelSummaryBarRef = React.createRef();
  }

  componentDidUpdate() {
    const { setTravelSummaryBarHeight, travelSummaryBarHeight } = this.props;

    if (this.travelSummaryBarRef.current && this.travelSummaryBarRef.current.clientHeight !== travelSummaryBarHeight) {
      setTravelSummaryBarHeight(this.travelSummaryBarRef.current.clientHeight);
    }
  }

  handleOnClickOpenSummary() {
    this.setState(({ open }) => ({ open: !open }));
  }

  render() {
    const { packagesSearch, config, travelSummaryBarBottom } = this.props;
    const { fetching, value } = packagesSearch;
    const { open } = this.state;

    if (fetching === null && value === null) {
      return null;
    }

    const fetchingFinished = fetching !== null && fetching !== FETCHING_STATUS_IN_PROGRESS;
    const noResults = value === null || (value !== null && value.packages === undefined);

    if (fetchingFinished && noResults) {
      return null;
    }

    return (
      <TravelSummaryBarComponent
        open={open}
        config={config}
        onClickOpenSummary={this.handleOnClickOpenSummary}
        travelSummaryBarBottom={travelSummaryBarBottom}
        travelSummaryBarRef={this.travelSummaryBarRef}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    packagesSearch: state.checkoutPagePackagesSearch,
    travelSummaryBarBottom:
      state.settings.value.customSettings && state.settings.value.customSettings.travelSummaryBarBottom,
    travelSummaryBarHeight: state.refs.travelSummaryBarHeight,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTravelSummaryBarHeight(height) {
      dispatch(setTravelSummaryBarHeight(height));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TravelSummaryBar);
